import { Link } from "react-router-dom";
import LegalLayout from "@/components/legal/LegalLayout";

const TOC = [
  { id: "general", label: "Educational purpose" },
  { id: "financial", label: "Financial disclaimer" },
  { id: "earnings", label: "No earnings or results guarantee" },
  { id: "health", label: "Health and wellbeing disclaimer" },
  { id: "mental", label: "Emotional and mental health" },
  { id: "science", label: "Science and interpretation" },
  { id: "testimonials", label: "Testimonials" },
  { id: "links", label: "External links and affiliates" },
  { id: "responsibility", label: "Your responsibility" },
];

const SUMMARY = [
  "Our content is education, not professional advice.",
  "The author is not a SEBI-registered or licensed financial adviser.",
  "Our health content is not medical advice and does not treat any condition.",
  "We do not promise any specific financial or personal results.",
];

export default function DisclaimerPage() {
  return (
    <LegalLayout title="Disclaimer" activePath="/disclaimer" summary={SUMMARY} toc={TOC}>
      <section className="tc__sec" id="general">
        <h2>Educational purpose</h2>
        <p>All books, journals, practice materials, emails and Website content by Rajesh Sivacharya are provided for general education, reflection and personal growth. They share the author's experiences, perspectives and frameworks, informed by published research.</p>
        <p>They are not a substitute for professional advice tailored to your circumstances, and reading them does not create any professional relationship between you and us.</p>
      </section>

      <section className="tc__sec" id="financial">
        <h2>Financial disclaimer</h2>
        <p>Content about money, including <em>Rich by Thirty, Broke by Thirty</em> and The Identity Shift Wealth Journal, is general financial education. It is <strong>not</strong> financial, investment, tax or legal advice.</p>
        <p>The author is not a SEBI-registered investment adviser or research analyst, nor a registered financial adviser in any other country, and does not recommend specific securities, funds or financial products. Historical returns and examples are illustrations only, not predictions or guarantees. All investments carry risk, including the possible loss of capital. Laws, tax rules and financial products differ between countries and change over time.</p>
        <p>Please consult a qualified, registered professional before making financial decisions.</p>
      </section>

      <section className="tc__sec" id="earnings">
        <h2>No earnings or results guarantee</h2>
        <p>We do not promise that you will earn, save or accumulate any particular amount of money, or achieve any particular outcome. Any figures, stories or examples are illustrative and not typical results. Your results depend on your circumstances, choices, effort, market conditions and factors outside anyone's control.</p>
      </section>

      <section className="tc__sec" id="health">
        <h2>Health and wellbeing disclaimer</h2>
        <p>Content about health, habits, emotions and the body, including The Identity Shift Health Journal, supports personal reflection and habit-building. It is <strong>not</strong> medical, psychological or nutritional advice, and it is not intended to diagnose, treat, cure or prevent any disease or condition.</p>
        <p>Always consult a qualified doctor or health professional about your health, before changing your diet, exercise or medication, and never delay or disregard professional advice because of something you read in our products.</p>
      </section>

      <section className="tc__sec" id="mental">
        <h2>Emotional and mental health</h2>
        <p>Some of our content, especially <em>The Inheritance of You</em> and the Relationships Journal, invites reflection on family history and difficult experiences. This can bring up strong emotions. Our products are not therapy and are not a substitute for a licensed mental health professional.</p>
        <p>If you are in distress or crisis, please contact a qualified professional or your local emergency services. In India, you can call Tele-MANAS on 14416.</p>
      </section>

      <section className="tc__sec" id="science">
        <h2>Science and interpretation</h2>
        <p>Our books discuss research in neuroscience, psychology, epigenetics and physics. Where we extend established findings into practical frameworks for personal change, those extensions are the author's interpretation, and we aim to say so clearly in the text. Scientific understanding evolves, and some topics remain actively debated by researchers.</p>
      </section>

      <section className="tc__sec" id="testimonials">
        <h2>Testimonials</h2>
        <p>Testimonials reflect individual experiences of real readers, shared with permission. They are not a guarantee or prediction of your results. Where a reviewer received a free copy or other benefit, we disclose it.</p>
      </section>

      <section className="tc__sec" id="links">
        <h2>External links and affiliates</h2>
        <p>The Website may link to other websites, books or resources. We do not control and are not responsible for their content.</p>
      </section>

      <section className="tc__sec" id="responsibility">
        <h2>Your responsibility</h2>
        <p>By using our products, you accept responsibility for your own decisions and actions. To the extent permitted by law, we are not liable for any loss or damage arising from your use of our content, as set out in our <Link to="/terms">Terms and Conditions</Link>.</p>
      </section>
    </LegalLayout>
  );
}
